import React, { useState } from 'react';

import LabelInfo from '../../../../../components/LabelInfo';
import { setNumberWithComma } from '../../../../../lib/common';
import Button from '../../../../../components/Button';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import { ACCOUNT_USER_DETAIL_POINT_HISTORY_LIST_FILTER_OPTION_MODEL } from './models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { ACCOUNT_USER_POINT_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/accountUserConstants';
import { columns } from './columns';
import { useAccountUserDetailPointList, useAccountUserPointDetail, useCheckValidGeneratePoint } from './hooks';
import GeneratePointUserDetailModal from './GeneratePointUserDetailModal';
import GeneratePointValidSuccessModal from './GeneratePointValidSuccessModal';
import GeneratePointValidFailModal from './GeneratePointValidFailModal';
import Can from '../../../../../components/common/Can';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../constants/service/common/userPermissions';

const AccountUserDetailPointInfo = (props) => {
  const { userId, isActive } = props;

  const [isModalOpen, setIsModalOpen] = useState();
  const { checkValidGeneratePoint, resetValidResult, validResult } = useCheckValidGeneratePoint();
  const { userPersonalInfo, pointCauseSelectList } = useAccountUserPointDetail({ userId, isActive });
  const { pointHistoryList, pagination, filterOption, setPagination, setFilterOption } = useAccountUserDetailPointList({
    userId,
    isActive,
  });

  const getPointHistoryList = ({ filterOption, pagination }) => {
    pagination && setPagination(pagination);
    filterOption && setFilterOption(filterOption);
  };

  /**
   *  포인트 발급 모달 띄우기
   */
  const handleGeneratePoint = () => {
    setIsModalOpen(true);
  };

  const handleClosePointDetailModal = () => setIsModalOpen(false);

  return (
    <div className="account-user-detail-content">
      {/* 포인트 내역 */}
      <div className="account-user-detail-section user-point-info">
        <div className="title">포인트 내역</div>

        <div className="account-user-detail-section-content">
          <div className="point-summary">
            <LabelInfo label="포인트" info={setNumberWithComma(userPersonalInfo.pointAmount)} />

            <LabelInfo label="사용된 포인트" info={setNumberWithComma(userPersonalInfo.usedPointAmount)} />
          </div>
          <Can I={PERMISSION_ACTIONS.CREATE} a={PERMISSION_SUBJECTS.POINT}>
            <div className="point-generate">
              <Button color="primary" isRadius text="포인트 발급하기" onClick={handleGeneratePoint} />
            </div>
          </Can>

          <TableWithSummary
            className="account-user-detail-section-list"
            data={pointHistoryList.list}
            totalCnt={pointHistoryList.totalCnt}
            initialOption={{
              filterOption: ACCOUNT_USER_DETAIL_POINT_HISTORY_LIST_FILTER_OPTION_MODEL,
              pagination: LIST_PAGINATION_MODEL,
            }}
            isStriped={true}
            emptyText={ACCOUNT_USER_POINT_LIST_TABLE_EMPTY_TEXT}
            showPagination
            maxHeight={1200}
            filterOption={filterOption}
            pagination={pagination}
            getList={getPointHistoryList}
            columns={(utils) =>
              columns({
                pointCauseSelectList,
                ...utils,
              })
            }
          />
        </div>
      </div>
      {isModalOpen && (
        <GeneratePointUserDetailModal
          userPersonalInfo={userPersonalInfo}
          pointCauseSelectList={pointCauseSelectList}
          closeModal={handleClosePointDetailModal}
          checkValidGeneratePoint={checkValidGeneratePoint}
        />
      )}
      {validResult.impossibleCnt === 0 && (
        <GeneratePointValidSuccessModal closeModal={resetValidResult} validResult={validResult} />
      )}
      {validResult.impossibleCnt > 0 && (
        <GeneratePointValidFailModal closeModal={resetValidResult} validResult={validResult} />
      )}
    </div>
  );
};

export default AccountUserDetailPointInfo;
